<template>

  <div class="v-radio-list">
    <div class="v-radio-conntent">

      <label for="v-radio" @click="emitValue()">
        {{label}}
        <input type="radio" v-model="value" name="v-radio" ref="radio">
        <span>
          <img :src="checked" v-if="value" />
        </span>
      </label>

    </div>
  </div>


</template>

<script>
export default{

  props: {
    // selected: {
    //   required: false,
    //   type: [Boolean, String, Number],
    //   default: false
    // },
    label: {
      required: false,
      type: String, // <Object>
      default: 'label',
    },
    label: {
      required: false,
      type: String, // <Object>
      default: 'label',
    },
    options: {
      required: true,
      type: Array, // <Object>
      default: [],
    },
    disabled: {
      required: false,
      type: Array,
      default: [],
    },
    required: {
      required: false,
      type: Boolean,
      default: true
    },
    group: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  data: function(){

    return {
      // valore inziale della radio
      value: this.selected,
      checked: window.location.origin + '/media/icons/checked.png'
    }

  },

  computed:  {

    isBool: function () {
      return typeof this.selected == 'boolean'
    },

  },

  methods: {

    emitValue: function(){

      this.value = this.isBool() ? !this.value : null;
      this.$emit('input', this.value);

    }

  }

}
</script>

<style scoped>
div.v-radio{
  position: relative;
}
div.v-radio.disabled::before{
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: #ffffff;
  opacity: .5;
}
div.v-radio label{
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 1em;
  user-select: none;
}
div.v-radio label input{
  position: absolute;
  cursor: pointer;
  z-index: -1;
  opacity: 0;
  top: 0;
  left: 0;
}
div.v-radio label span{
  position: absolute;
  top: 49%;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: transparent;
  border: 1px solid var(--radio-gray);
  transform: translateY(-50%);
}
div.v-radio label input:checked + span{
  background-color: var(--green);
  border-color: var(--green);
}
div.v-radio label input:checked + span img{
  display: block;
}
div.v-radio img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}
div.v-radio span.purple::after{
  background-color: var(--purple);
}
</style>
